export enum EpcLoanActionTypes {
  Register = 'TpoRegister',
  ImportAdditionalData = 'TpoImportAdditionalData',
  Submit = 'TpoSubmit',
  Resubmit = 'TpoResubmit',
  RequestTitleFees = 'TpoRequestTitleFees',
  OrderAus = 'TpoOrderAus',
  OrderReIssueCredit = 'TpoOrderReissueCredit',
  Disclosures = 'TpoDisclosures',
  LockRequest = 'TpoLockRequest',
  FloatLock = 'FloatLock',
  ChangedCircumstance = 'TpoChangedCircumstance',
  RunLPUnderwriting = 'TpoRunLP Underwriting',
  ViewPurchaseAdvice = 'TpoViewPurchaseAdvice',
  SubmitPurchase = 'TpoSubmitPurchase',
  LockExtension = 'TpoLockExtension',
  CancelLock = 'TpoCancelLock',
  Relock = 'TpoRelock',
  RePrice = 'TpoRePrice',
  VoidLock = 'TpoVoidLock',
  Withdraw = 'TpoWithdrawal',
  RequestLoanEstimate = 'TpoRequestLE',
  GenerateLestimateDisclosure = 'TpoGenerateLEDisclosure',
  OrderAppraisal = 'TpoOrderAppraisal',
}
